import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=30fa6f62&"
import script from "./MyTable.vue?vue&type=script&lang=ts&"
export * from "./MyTable.vue?vue&type=script&lang=ts&"
import style0 from "./MyTable.vue?vue&type=style&index=0&id=30fa6f62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports